export default "__VITE_ASSET__CH$d7e3C__"